export default "__VITE_ASSET__25e75cb8__"